




















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class HeartSolidIcon extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#EB3B47' }) readonly fill?: string;
  @Prop({ default: '#EB3B47' }) readonly stroke?: string;
}
